<script>
export default {
  name: "PatientLabQueue",

  data() {
    return {
      patients: [],
      search: ``,
    };
  },

  mounted() {
    this.fetchQueue();
  },

  methods: {
    fetchQueue() {
      this.$root.loading = true;
      let url = `Lab/GetPastLabQueue`;
      url += this.search ? `?SearchText=${this.search}` : ``;

      this.$http
        .get(url)
        .then((response) => {
          this.patients = response.data;
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
  },
}
</script>
<template>
  <tail-base-layout>
    <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="font-medium">Past Lab Queue</h5>
        </template>
        <template v-slot:card-body>
          <div class="w-full overflow-auto max-h-screen">
            <div class="w-full flex flex-wrap">
              <div class="md:w-1/4 sm:w-1/2 p-tiny">
                <input
                  type="text"
                  v-model.trim="search"
                  @keydown.enter="fetchQueue"
                  class="input-sm input-control text-sm"
                  placeholder="Search"
                />
              </div>
              <div class="w-1/4 p-tiny">
                <button
                  class="btn-sm btn-primary text-xs rounded"
                  @click.prevent="fetchQueue"
                >
                  <i class="fa fa-search"></i> Filter
                </button>
              </div>
            </div>
            <table class="w-full table table-hover">
              <thead class="bg-blue-500 text-xs">
                <tr class="flex text-white w-full">
                  <th class="p-tiny flex-1">Patient</th>
                  <th class="p-tiny flex-1">Date</th>
                  <th class="p-tiny flex-1">Status</th>
                  <th class="p-tiny flex-1">Payment</th>
                  <th class="p-tiny flex-1">Residence</th>
                  <th class="p-tiny flex-1">Select</th>
                </tr>
              </thead>
              <tbody
                class="text-xs bg-gray-100 font-semibold flex flex-col items-center overflow-auto w-full"
                style="max-height: 65vh;"
              >
                <tr
                  class="flex w-full"
                  v-for="(pat, idx) in patients"
                  :key="idx"
                >
                  <td class="p-tiny flex-1">
                    <h5 class="text-sm text-gray-900">{{ pat.names }}</h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      MRN: {{ pat.patientId }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      IP: {{ pat.ipfileno || `-` }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      OP: {{ pat.opfileno || `-` }}
                    </h5>
                    <h5 class="text-xs leading-5 text-gray-700">
                      DOB: {{ pat.dob | dateFormat }}
                    </h5>
                  </td>
                  <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                  <td class="p-tiny flex-1">{{ pat.patientstatus }}</td>
                  <td class="p-tiny flex-1">{{ pat.payment }}</td>
                  <td class="p-tiny flex-1">{{ pat.residence }}</td>
                  <td class="p-tiny flex-1">
                    <router-link
                      :to="{
                        name: `lab.record-tests.past-create`,
                        params: { patientID: pat.patientId },
                      }"
                      class="btn-sm text-xs btn-primary rounded ml-1"
                    >
                      <i class="fa fa-pen"></i
                    ></router-link>
                  </td>
                </tr>
              </tbody>
              <tfoot class="bg-gray-300">
                <tr class="w-full flex">
                  <td colspan="6" class="p-tiny flex-1"></td>
                  <td class="p-tiny w-1/5">Total: {{ patients.length }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
      </tail-card>
    </template>
  </tail-base-layout>
</template>
